var angular = require('angular');
var module =  angular.module("app.directives");
var Promise = require('bluebird');
var $ = require('jquery');


module.factory('Tour', function($rootScope, $timeout, $state){
  var service = $rootScope.$new();

  angular.extend(service, {

      config: {
        body: {
          className: 'rr-tour-body'
        },
        target: {
          className: 'rr-tour-target'
        },
        toast: {
          className: 'rr-tour-toast'
        }
      },

      current: false,
      triggers: {},

      // Methods
      Start: start,
      Stop: stop,
      Next: function(){
        return goToStep(service.current.step + 1);
      },
      Previous: function(){
        return goToStep(service.current.step - 1);
      },
      GoToStep: goToStep,


      TriggerOn: triggerAppend,

      Wait: {
        Trigger: triggerGet,
        State: waitState,
      }
  });

  window.Tour = service;
  return service;

  function start(tour, step){
    return new Promise(function(resolve, reject){

      if (!tour) {
        return reject(new Error('no tour specified'));
      }

      if (!tour.steps || !tour.steps.length) {
        return reject(new Error('no steps specified in the tour'));
      }

      if (service.current.active) {
        return service.Stop().finally(function(){
          resolve(tourSetup(tour, step));
        });
      }

      resolve(tourSetup(tour, step))
    })
  }

  function tourSetup(tour, step){
    // copy original tour, merge in default config.
    tour = angular.copy(tour);
    tour.config = angular.merge({}, service.config, tour.config);

    tour.steps = tour.steps.map(function(step){
      return angular.merge({}, tour.config, step)
    })

    service.current = {
      active: true,
      tour: tour,
      step: 0
    }
    service.$broadcast('start', service.current);
    goToStep(step);
    return service.current;
  }


  function tourTeardown(){
    var currentStepNumber = service.current.step;
    if (service.current.active && currentStepNumber) {
      var tour = service.current.tour;
      var currentStep = tour.steps[currentStepNumber - 1];
      if (currentStep) stepTeardown(currentStep, currentStepNumber);
    }

    service.current = {
      active: false
    }
    service.$broadcast('stop');
  }

  function stop() {
    return new Promise(function(resolve, reject){
      if (!service.current) {
        return reject(new Error('no tour running'));
      }

      tourTeardown();
      resolve();
    })
  }

  // configures and waits for "after" promises on current step
  // and "before" promsies on the step passed in (next step).
  function goToStep(nextStepNumber, backward){
    nextStepNumber = nextStepNumber || 1;

    // get current tour
    var tour = service.current && service.current.tour;

    // create promise
    var promise = Promise.resolve(true);

    // throw error if not running
    if (!tour) {
      return promise.then(function(){
        throw new Error("no tour running");
      })
    }

    // get current step number
    var currentStepNumber = service.current.step;
    var currentStep = tour.steps[currentStepNumber - 1];

    // get nextStep
    var nextStep = tour.steps[nextStepNumber - 1];

    // cleanup currentStep
    if (currentStepNumber > 0) {
      promise = promise.then(function(){
        service.current.waiting = true;

        var afterPromise = currentStep.after && currentStep.after.call(service)
        if (afterPromise && !afterPromise.then) {
          throw new Error("after function must return a promise")
        }

        return afterPromise
      })

      promise = promise.then(function(){
        $timeout(function(){
          stepTeardown(currentStep, currentStepNumber);
        })
        delete service.current.waiting;
      })
    }

    promise = promise.then(function(){
      // if no next step, return;
      if (!nextStep) return;

      service.current.waiting = true;

      // check for before promise
      var beforePromise = nextStep.before && nextStep.before.call(service)
      if (beforePromise && !beforePromise.then) {
        throw new Error("before function must return a promise")
      }

      return beforePromise;
    })

    return promise.then(function(){
      // if no next step, return service.stop;
      if (!nextStep) return service.Stop();

      $timeout(function(){
        stepSetup(nextStep, nextStepNumber);
      })
      delete service.current.waiting;
    }).catch(function(){ /* do nothing */ })
  }

  // this is triggered when a step is triggered
  function stepSetup(step, number){
    service.$broadcast('step', step, number);
    service.$broadcast('step-' + number, step, number);
    service.current.step = number;

    $(step.target.el).focus();
    $(step.target.el).addClass(step.target.className);
    if (step.target.triggerNextOn) {
      $(step.target.el).bind(step.target.triggerNextOn, service.Next);
    }

    if (step.transport) {
      step.unbindTransport = step.transport.call(service, service.Previous, service.Next, service.Stop);
    }

    $('body').addClass(step.body.className);
  }

  // This is triggered when a step has been left.
  function stepTeardown(step, number){
    service.$broadcast('teardown-step', step, number);
    service.$broadcast('teardown-step-' + number, step, number);

    $(step.target.el).blur();
    $(step.target.el).removeClass(step.target.className);
    if (step.target.triggerNextOn) {
      $(step.target.el).unbind(step.target.triggerNextOn, service.Next);
    }

    if (step.transport && typeof step.unbindTransport == 'function') {
      step.unbindTransport();
    }

    $('body').removeClass(step.body.className);
  }




  // function triggerSetup(){
  //   service.trigger = {
  //     active: true,
  //     tally: 0,
  //   }
  //
  //   var promise = new Promise(function(resolve, reject){
  //     // this function accepts a promise, and when called
  //     // increases a tally, and only decreases it when the
  //     // supplied promise has been resolved.
  //     // When all promises have been resolved, it will
  //     // resolve the outer promise.
  //     service.trigger.append = function(p){
  //       service.trigger.tally++;
  //       p.finally(function(){
  //         service.trigger.tally--;
  //         service.trigger.tally === 0 && resolve();
  //       })
  //     }
  //
  //   }).finally(function(){
  //     triggerTeardown();
  //   })
  //
  //   service.trigger.promise = promise;
  // }

  function setupTrigger(name){
    var obj = service.triggers[name] || (service.triggers[name] = {
      active: true,
      tally: 0
    })

    var promise = new Promise(function(resolve, reject){
      // this function accepts a promise, and when called
      // increases a tally, and only decreases it when the
      // supplied promise has been resolved.
      // When all promises have been resolved, it will
      // resolve the outer promise.
      obj.append = function(p){
        obj.tally++;
        p.finally(function(){
          obj.tally--;
          obj.tally === 0 && resolve();
        })
      }
    })

    obj.promise = promise;
    return obj;
  }

  function teardownTrigger(name){
    delete service.triggers[name];
  }

  function triggerAppend(name, p){
    if (!service.current.active) return;
    setupTrigger(name).append(p);
    return p;
  }

  function triggerGet(name){
    function get(){
      var trigger = service.triggers[name];
      if (!trigger) return null;

      trigger.promise.finally(function(){
        teardownTrigger(name);
      })

      return trigger.promise;
    }

    var p = get();
    if (p) return p;

    return Promise.delay(2000).then(function(){
      var p = get();
      if (p) return p;
      var err = new Error('No trigger with name "' + name + '" setup yet');
      console.error(err);
      throw err;
    })
  }

  function waitState(stateName){
    return new Promise(function(resolve, reject){
      if (stateName && stateName === $state.current.name) {
        resolve();
        return;
      }

      var off = $rootScope.$on('$stateChangeStart', function(event, toState){
        if (stateName && stateName !== toState.name) return;
        resolve();
        off();
      })
    })
  }
})



module.directive('tourToast', function(Tour){
  return {
    restrict: 'E',
    template: require('./toast.pug'),
    scope:{

    },
    replace:true,
    link: function(scope, el, attrs){

      scope.$watch(function(){
        return Tour.current;
      }, function(current){
        scope.active = !!current.active;
        scope.tour = current.tour;
        scope.step = current.active && current.step ? current.tour.steps[current.step - 1] : null;
      }, true)


      scope.close = function(){
        Tour.Stop();
      }
      scope.next = function(){
        Tour.Next();
      }

      scope.trigger = function(tour){
        Tour.Stop();
        Tour.Start(tour)
      }


    }
  }
})
